import { MapMarkerOffOutlineIcon } from './MapMarkerOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 48218DC3-F2A6-4C4B-9B5E-0648815B8864
 * name map-marker-off-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-off-outline.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const LocationOffOutlineIcon = MapMarkerOffOutlineIcon;
export default LocationOffOutlineIcon